export default __webpack_public_path__ + "static/media/What-is-Git.8592c0d6.png";